const reIsOctal = /^0o[0-7]+$/i
export default reIsOctal
